import { PubSubEvents } from "vue-app/types/pubSub.types";
import { PubSub } from "vue-app/utils/pubSub";

const pubSub = new PubSub<PubSubEvents>();

if (window.pubSub === undefined) {
  window.pubSub = pubSub;
}
